import { render } from "./Dashboard-page.vue?vue&type=template&id=1c74805e&scoped=true"
import script from "./Dashboard-page.vue?vue&type=script&lang=js"
export * from "./Dashboard-page.vue?vue&type=script&lang=js"

import "./Dashboard-page.vue?vue&type=style&index=0&id=1c74805e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c74805e"]])

export default __exports__